export interface AHProduct {
  webshopId: number
  title: string
  price: number | null
  unitSize: string
  imageUrl: string
  available: boolean
}

export interface AHSearchResult {
  success: boolean
  results?: Record<string, AHProduct[]>
  error?: string
}

const AH_ADD_MULTIPLE_URL = 'https://www.ah.nl/mijnlijst/add-multiple'
const MAX_DEEP_LINK_ITEMS = 50

class AHService {
  async search(queries: string[], size = 10): Promise<AHSearchResult> {
    const unique = [...new Set(queries.map((query) => query.trim()).filter(Boolean))]
    if (!unique.length) {
      return { success: true, results: {} }
    }

    try {
      const response = await fetch('/api/ah/search', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ queries: unique, size }),
      })

      const data = (await response.json()) as { results?: Record<string, AHProduct[]>; error?: string }
      if (!response.ok) {
        return { success: false, error: data.error || 'AH-zoekopdracht mislukt.' }
      }

      return { success: true, results: data.results ?? {} }
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'AH is momenteel niet bereikbaar.',
      }
    }
  }

  /**
   * Builds the Albert Heijn shopping-list deep link. Opening it in the user's
   * own (logged-in) browser adds every product to their real AH basket.
   * The link is not idempotent — build it fresh each time and open it once.
   */
  buildAddToCartUrl(items: Array<{ webshopId: number; quantity: number }>): string {
    const params = items
      .filter((item) => item.webshopId && item.quantity > 0)
      .slice(0, MAX_DEEP_LINK_ITEMS)
      .map((item) => `p=${item.webshopId}:${Math.round(item.quantity)}`)
      .join('&')

    return `${AH_ADD_MULTIPLE_URL}?${params}`
  }

  get maxItems(): number {
    return MAX_DEEP_LINK_ITEMS
  }
}

export const ahService = new AHService()
